// importer vos composantes ici
import Carousel from './components/Carousel.js';
import Form from './components/Form.js';
import Header from './components/Header.js';
import Scrolly from './components/Scrolly.js';
import YouTube from './components/YouTube.js';
import ContactModal from './components/ContactModal.js';
import BubbleHeader from './components/BubbleHeader.js';
import SmoothScroller from './components/SmoothScroller.js';
import BeforeAfter from './components/BeforeAfter.js';
import ConveyorCarousel from './components/ConveyorCarousel.js';
import TiltEffect from './components/TiltEffect.js';
import NeonGlitch from './components/NeonGlitch.js';
import MagneticCursor from './components/MagneticCursor.js';
import Scrollbar from './components/Scrollbar.js';
import Scrollytelling from './components/Scrollytelling.js';
import HubBackground from './components/HubBackground.js';
import MagneticButtons from './components/MagneticButtons.js';
import HubIntro from './components/HubIntro.js';
import AIDisclosure from './components/AIDisclosure.js';
import Lightbox from './components/Lightbox.js';
import PageTransition from './components/Pagetransition.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      // Mettez votre liste de composantes ici
      Carousel,
      Form,
      Header,
      YouTube,
      Scrolly,
      ContactModal,
      BubbleHeader,
      SmoothScroller,
      BeforeAfter,
      ConveyorCarousel,
      TiltEffect,
      NeonGlitch,
      MagneticCursor,
      Scrollbar,
      Scrollytelling,
      HubBackground,
      MagneticButtons,
      HubIntro,
      AIDisclosure,
      Lightbox,
      PageTransition,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
